import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import _ from "lodash";

const BarChartPyramid = (props) => {
  const ageWiseChart = Array.isArray(props?.homePageCharts) ? props.homePageCharts : [];

  const barChart1 = {
    chart: {
      type: "bar",
      backgroundColor: null,
      height:'320',
      width: '600'
    },
    title: {
      text: "",
    },
    xAxis: {
      categories: [
        "0-1 YEARS",
        "1-2 YEARS",
        "2-5 YEARS",
        "5-10 YEARS",
        "10-25 YEARS",
        "25 AND ABOVE",
      ],
      minWidth: 900,
      gridLineWidth: 0,
    },
    yAxis: {
      title: {
        text: "Number of Individuals",
        enabled: false
      },
      min: -100, // Set a minimum value to center the 0%
      max: 100, // Adjust the maximum value as needed
      labels: {
        enabled: false, // Hide Y-axis labels
      },
      gridLineWidth: 0,
    },
    credits:{
        enabled: false,
      },
    plotOptions: {
      series: {
        stacking: "normal",
        groupPadding: 0, // Remove padding between groups of bars
        pointPadding: 0, // Remove padding between bars within a group
      },
    },
    tooltip: {
      formatter: function () {
        const value = Math.abs(this.point.y); // Get the absolute value
        return `<b>${this.series.name}</b><br>${this.point.category}: ${value}`;
      },
    },
    series: [
      {
        name: "Male",
        data: [
          _.find(ageWiseChart,{indicatorname:"0-1 year-Male"})?-(_.find(ageWiseChart,{indicatorname:"0-1 year-Male"}).counts):-0,
          _.find(ageWiseChart,{indicatorname:"1-2 years-Male"})?-(_.find(ageWiseChart,{indicatorname:"1-2 years-Male"}).counts):-0,
          _.find(ageWiseChart,{indicatorname:"2-5 years-Male"})?-(_.find(ageWiseChart,{indicatorname:"2-5 years-Male"}).counts):-0,
          _.find(ageWiseChart,{indicatorname:"5-10 years-Male"})?-(_.find(ageWiseChart,{indicatorname:"5-10 years-Male"}).counts):-0,
          _.find(ageWiseChart,{indicatorname:"10-25 years-Male"})?-(_.find(ageWiseChart,{indicatorname:"10-25 years-Male"}).counts):-0,
          _.find(ageWiseChart,{indicatorname:"25 and above-Male"})?-(_.find(ageWiseChart,{indicatorname:"25 and above-Male"}).counts):-0
        ],
        color: "#002060",
      }, // Negative values for male population
      {
        name: "Female",
        data: [
          _.find(ageWiseChart,{indicatorname:"0-1 year-Female"})?-(_.find(ageWiseChart,{indicatorname:"0-1 year-Female"}).counts):-0,
          _.find(ageWiseChart,{indicatorname:"1-2 years-Female"})?-(_.find(ageWiseChart,{indicatorname:"1-2 years-Female"}).counts):-0,
          _.find(ageWiseChart,{indicatorname:"2-5 years-Female"})?-(_.find(ageWiseChart,{indicatorname:"2-5 years-Female"}).counts):-0,
          _.find(ageWiseChart,{indicatorname:"5-10 years-Female"})?-(_.find(ageWiseChart,{indicatorname:"5-10 years-Female"}).counts):-0,
          _.find(ageWiseChart,{indicatorname:"10-25 years-Female"})?-(_.find(ageWiseChart,{indicatorname:"10-25 years-Female"}).counts):-0,
          _.find(ageWiseChart,{indicatorname:"25 and above-Female"})?-(_.find(ageWiseChart,{indicatorname:"25 and above-Female"}).counts):-0
        ],
        color: "#0070c0",
      }, // Positive values for female population
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={barChart1} />;
};


export default BarChartPyramid;